import { render, staticRenderFns } from "./model-nav.vue?vue&type=template&id=5f067644&scoped=true&lang=html"
import script from "./model-nav.vue?vue&type=script&lang=js"
export * from "./model-nav.vue?vue&type=script&lang=js"
import style0 from "./model-nav.vue?vue&type=style&index=0&id=5f067644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f067644",
  null
  
)

export default component.exports